import request from '@/utils/request'
export function queryES(data,params){
	return request({
		url:'business/material/queryES',
        method:'post',
        data,
        params,
	})
}

// 类型列表
export function webList(params){
	return request({
		url:`business/big/webList?selectId=${params.selectId}&selectBigId=${params.selectBigId}`,
        method:'get',
	})
}
// 媒体类型
export function getTypes(params){
	return request({
		url:'business/big/getTypes',
        method:'get',
        params,
	})
}
// 获取资料详情
export function getLibraryDetails(params){
	return request({
		url:'business/material/details',
        method:'get',
        params,
	})
}
// 点赞
export function getPros(data){
	return request({
		url:'business/material/pros',
        method:'post',
        data,
	})
}
// 收藏
export function setCollect(data){
	return request({
		url:'business/collect',
        method:'post',
        data,
	})
}
// 举报
export function setReport(data){
	return request({
		url:'business/report/',
        method:'post',
        data,
	})
}
// 下载
export function getDownload(params){
	return request({
		url:'business/upload/download',
        method:'get',
        params,
        responseType: "blob",
	})
}
//记录下载次数
export function addDownbtn(params){
	return request({
		url:'business/material/updateDownloads',
        method:'post',
		data: params,
	})
}
//预览地址
export function yulanUrl(){
    return request({
        url: 'business/other/previewUrl',
        method: 'get',

    })
}
//动态tab栏的es筛选
export function TabqueryES(data,params){
	return request({
		url:'business/material/queryESTab',
        method:'post',
        data,
        params,
	})
}
//下载文件
export function getFile(params){
  return request({
    url:'business/material/getFile',
    method:'get',
    params,
  })
}
